import LabelButton from '../../../singleTenantWelcome/components/bottomBar/LabelButton';
import {AlreadyRegisteredIcon} from '../../../../assets/icons/Icons';
import {StyleSheet, View} from 'react-native';
import React from 'react';
import {Sizes} from '@proxyclick/hello-react-native';
import {useActivatedContext} from '../../../../common/context/IActivatedContext';
import {useTranslationsProvider} from '../../../../common/translations/useTranslationsProvider';

const iconSize = 25;

export interface IRegisteredButtonViewProps {
  onPress: () => void;
}

export const RegisteredButtonView = (props: IRegisteredButtonViewProps) => {
  const {companyData} = useActivatedContext().companyDataProvider;
  const {getTextForKey} = useTranslationsProvider({tenantData: companyData});

  return (
    <View style={styles.registeredButtonView}>
      <LabelButton
        textColor={companyData.kioskParameters.titleColor}
        testID={'notRegisteredYetButtonId'}
        iconLeft={
          <AlreadyRegisteredIcon width={iconSize} height={iconSize} stroke={companyData.kioskParameters.titleColor} />
        }
        text={getTextForKey('em_multiTenant_alreadyRegistered_button')}
        onPress={props.onPress}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  registeredButtonView: {
    marginLeft: iconSize,
    height: Sizes.xl,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
